import { useState } from 'react'
import Display from 'components/Admin/Shared/Container/Row/Display'
import Container from 'components/Admin/Shared/Container'
import PageHeader from 'components/Admin/Shared/PageHeader'
import Edit from 'components/Admin/Shared/Container/Row/Edit'
import AdjustPinMap from 'components/Admin/ContactInfo/Map'
import { PhoneForm } from 'components/Admin/ContactInfo/forms/Phone'
import { ContactEmailForm } from 'components/Admin/ContactInfo/forms/ContactEmail'
import { WebsiteForm } from 'components/Admin/ContactInfo/forms/Website'
import { useDispatch, useSelector } from 'react-redux'
import { getAffiliate, getUser } from 'store/selectors'
import {
  updateContactEmail,
  updatePhone,
  updateWebsite,
} from 'store/slices/DirectoryPage/basicInfo'
import { User } from 'types'

export default function ContactInfo() {
  const user = useSelector(getUser) as User
  const dispatch = useDispatch()
  const [isEditingPhone, setIsEditingPhone] = useState(false)
  const [isEditingContactEmail, setIsEditingContactEmail] = useState(false)
  const [isEditingWebsite, setIsEditingWebsite] = useState(false)
  const affiliate = useSelector(getAffiliate)
  const basicInfo = affiliate?.basicInfo
  const effectiveDate = new Date(affiliate.effectiveDate)
  const insuranceExpiration = new Date(affiliate.insuranceExp)

  return (
    <>
      <PageHeader title={'Contact Info'} hideLinks />
      <section>
        <Container
          header='Basic Info'
          subHeader='Edit the phone, email, and website for your affiliate below. To update the affiliates address contact <a href="mailto:affiliatesupport@crossfit.com">affiliate support</a>.'
        >
          {isEditingPhone ? (
            <Edit label='Phone'>
              <PhoneForm
                user={user}
                affiliateId={affiliate?.id}
                defaultValue={affiliate?.contactPhone}
                setIsEditing={setIsEditingPhone}
                update={(newValue) => {
                  dispatch(updatePhone({ value: newValue }))
                }}
              />
            </Edit>
          ) : (
            <Display
              label='Phone'
              desc=''
              value={basicInfo?.phone?.value}
              isEditable
              setIsEditing={() => {
                setIsEditingWebsite(false)
                setIsEditingContactEmail(false)
                setIsEditingPhone(true)
              }}
            />
          )}
          {isEditingWebsite ? (
            <Edit label='Website' desc='Paste Website URL below'>
              <WebsiteForm
                affiliateId={affiliate?.id}
                defaultValue={basicInfo?.website?.value}
                setIsEditing={setIsEditingWebsite}
                update={(newValue) => {
                  dispatch(updateWebsite({ value: newValue }))
                }}
              />
            </Edit>
          ) : (
            <Display
              label='Website'
              desc=''
              value={basicInfo?.website?.value}
              isEditable
              setIsEditing={() => {
                setIsEditingWebsite(true)
                setIsEditingContactEmail(false)
                setIsEditingPhone(false)
              }}
            />
          )}
          {isEditingContactEmail ? (
            <Edit label='Contact Email'>
              <ContactEmailForm
                affiliateId={affiliate?.id}
                defaultValue={basicInfo?.contactEmail?.value}
                setIsEditing={setIsEditingContactEmail}
                update={(newValue) => {
                  dispatch(updateContactEmail({ value: newValue }))
                }}
              />
            </Edit>
          ) : (
            <Display
              label='Contact Email'
              desc='Contact for submissions'
              value={basicInfo?.contactEmail?.value}
              isEditable
              setIsEditing={() => {
                setIsEditingWebsite(false)
                setIsEditingContactEmail(true)
                setIsEditingPhone(false)
              }}
            />
          )}
          <Display
            label='Address'
            desc={
              affiliate.city +
              ', ' +
              (affiliate.stateCode != 'Na' && affiliate.stateCode != null
                ? affiliate.stateCode
                : affiliate.countryCode)
            }
            value={affiliate.address}
            isEditable={false}
          />
        </Container>
        <Container header='Affiliate Info' headerIcon='lock'>
          <Display
            label='Established Date'
            value={effectiveDate.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
            isEditable={false}
          />
          <Display
            label='Insurance Expiration'
            value={insuranceExpiration.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
            isEditable={false}
          />
        </Container>
        <Container
          header='Owner Info'
          subHeader='This information is used by CrossFit to contact you and will not be visible to the public.'
          headerIcon='lock'
        >
          <Display
            label='Owner'
            value={affiliate.lor?.firstName + ' ' + affiliate.lor?.lastName}
            isEditable={false}
          />

          <Display
            label='Phone Number'
            value={affiliate.lor?.contactPhone}
            isEditable={false}
          />

          <Display
            label='Email'
            value={affiliate.lor?.contactEmail}
            isEditable={false}
          />
        </Container>
        <Container
          header='Adjust Map Pin Location'
          subHeader={`Drag the pin on the map to the correct location, and then click “Set to Current Location” link above it. Your affiliate’s marker on map.crossfit.com will be updated within 24 hours. Please note: this will not update your address with CrossFit HQ. If you need your address changed or corrected, please <a href="mailto:affiliatesupport@crossfit.com">contact affiliate support</a>.`}
        >
          <AdjustPinMap />
        </Container>
      </section>
    </>
  )
}
